import React from "react";
import styled from "styled-components";
import LogoRound from "../Svg/Icons/LogoRound";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import { Colors } from "../../theme";
import { LogoBuyDackieIcon } from "../Svg";

export interface Props {
  color?: keyof Colors;
  cakePriceUsd?: number;
  showSkeleton?: boolean;
  chainId: number;
}

const PriceLink = styled.a`
  display: flex;
  align-items: center;
  svg {
    transition: transform 0.3s;
  }
  :hover {
    svg {
      transform: scale(1.2);
    }
  }
`;

const CakePrice: React.FC<React.PropsWithChildren<Props>> = ({
  cakePriceUsd,
  color = "textSubtle",
  showSkeleton = true,
  chainId,
}) => {
  return cakePriceUsd ? (
    <PriceLink
      href="https://dackieswap.xyz/swap?chain=baseGoerli&inputCurrency=0x2e9F75DF8839ff192Da27e977CD154FD1EAE03cf&outputCurrency=0xcf8E7e6b26F407dEE615fc4Db18Bf829E7Aa8C09"
      target="_blank"
    >
      {/* <LogoRound width="24px" mr="8px" /> */}
      <LogoBuyDackieIcon className="mobile-icon" />
      <Text ml="5px" color={color} bold>{`$${cakePriceUsd.toFixed(3)}`}</Text>
    </PriceLink>
  ) : showSkeleton ? (
    <Skeleton width={80} height={24} />
  ) : null;
};

export default React.memo(CakePrice);
